import GhiDanhPage from "./GhiDanhPage";
export default GhiDanhPage